import styled, { css } from 'styled-components';
import { FlexCenter } from '../../global/commonStyle';

interface Props {
  size?: number;
  backgroundColor?: string;
  type?: number;
  borderRadius?: string;
  iconSize?: number;
  isClickable?: boolean;
  fontSize?: string;
  lineHeight?: string;
}

const IconDiv = styled.div<Props>`
  ${FlexCenter}
  box-sizing: border-box;
  overflow: ${({ type }) => type === 4 && 'hidden'};
  border-radius: ${({ borderRadius }) => borderRadius || 'var(--border-radius-6)'};
  flex-shrink: 0;
  background-color: ${({ backgroundColor, type }) => {
    if (type === 3 || type === 4) return 'var(--background-primary)';
    return backgroundColor || 'var(--red)';
  }};
  border: ${({ type }) => (type === 1 || type === 2 ? '0.5px solid transparent' : '0.5px solid var(--border-primary)')};

  ${({ isClickable }) =>
    isClickable &&
    css`
      &:hover,
      &:active {
        opacity: 0.9;
      }
    `}

  p {
    margin: var(--space-0);
  }
  ${({ size }) =>
    size &&
    css`
      width: ${size}px;
      height: ${size}px;
    `}
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
  }
  svg {
    margin: var(--space-0);
    fill: var(--text-white);
  }
`;

const Text = styled.div<Props>`
  color: var(--text-white);
  /* Use CSS custom properties and calc() for font-size calculation */
  --icon-size: ${({ size }) => size ?? 0}px;
  font-size: ${({ fontSize, size }) => {
    if (fontSize) return fontSize;
    // Use CSS calc for proportional sizing: base size scales with icon size
    if (size === 20) return '11px';
    if (size === 36) return '16px';
    // Default: 13px
    return '13px';
  }};
  font-weight: 600;
  /* Use CSS custom properties for line-height calculation */
  line-height: ${({ lineHeight, size }) => {
    if (lineHeight) return lineHeight;
    // Line-height typically matches icon size for proper centering
    if (size === 20) return '20px';
    if (size === 36) return '36px';
    // Default: 23px
    return '23px';
  }};
`;

const EmojiDiv = styled.p<Props>`
  ${FlexCenter}
  margin: var(--space-0);
  font-size: ${({ iconSize }) => (iconSize ? `${iconSize}px` : '16px')};
  width: ${({ iconSize }) => (iconSize ? `${iconSize}px` : '16px')};
  height: ${({ iconSize }) => (iconSize ? `${iconSize}px` : '16px')};
`;

const SVGIconDiv = styled.div<Props>`
  ${FlexCenter}
  width: ${({ iconSize }) => (iconSize ? `${iconSize}px` : '16px')};
  height: ${({ iconSize }) => (iconSize ? `${iconSize}px` : '16px')};
`;

export { IconDiv, Text, EmojiDiv, SVGIconDiv };
